import { Alignment, Button, HTMLTable, Switch, InputGroup, FormGroup, Tabs, Tab } from '@blueprintjs/core';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import QRCode from 'qrcode.react';
import * as React from 'react';
import { toast } from 'react-toastify';
import { GenerateStore } from '../../stores/2fa/GenerateStore';
import { MDBBtn, MDBCol, MDBRow } from 'mdbreact';
import { LoginStore } from '../../stores/login/LoginStore';
import AuthCode from 'react-auth-code-input';
import { copyToClipboard } from '../../utils';

interface Props { }

@observer
export class GeneratePage extends React.Component<Props, {}> {

  obs = observable({
    code: "" as string,
    manul_code: "" as string,
    active2fa: false as boolean,
    needvalidated: true as boolean,
    codeValidation: "" as string,
    selectedTab: "android" as string,
    continuar: "1" as string,
    manual: false
  })

  constructor(props) {
    super(props);
  }

  async componentDidMount(): Promise<void> {

    let ret = await GenerateStore.handleGetStatus()
    this.obs.active2fa = ret.status
    this.obs.needvalidated = ret.pending_validation

  }

  async handleValidarCode(): Promise<void> {

    if (this.obs.codeValidation) {

      let ret: boolean = await GenerateStore.handleValidateInitialCode(this.obs.codeValidation)

      this.obs.needvalidated = ret

      if (!this.obs.needvalidated) {
        this.obs.code = ""
        this.obs.continuar = "5"
      }

    } else {
      toast.error("Código obrigatório", {});
      return
    }
  }

  onClose() {

    GenerateStore.obs.open_2fa = false

    GenerateStore.obs.codeBackup = []

  }

  async handleCodeBackup(): Promise<void> {

    GenerateStore.obs.codeBackup = await GenerateStore.handleGenerateCodeBackup()

    this.obs.continuar = "5"

  }

  render() {

    let values = GenerateStore.obs.codeBackup.map((itens: any) => {
      return (
        <tr key={itens}>
          <td>{itens}</td>
        </tr>
      );
    });

    const handleOnChange = (res: string) => {

      this.obs.codeValidation = res;

    };

    const handleContinue = async (e: string) => {

      this.obs.continuar = e

    }

    const handleGenerateContinue = async (e: string) => {

      if (e) {
        GenerateStore.obs.codeBackup = []
        let resp = await GenerateStore.handleGenerateCode()

        this.obs.code = resp[0]
        this.obs.manul_code = resp[1]

      }

      this.obs.continuar = e
      this.obs.manual = false

    }

    const handleRegenerate = async (e: string) => {

      if (e) {
        GenerateStore.obs.codeBackup = []
        let resp = await GenerateStore.handleGenerateCode()

        this.obs.code = resp[0]
        this.obs.manul_code = resp[1]

      }

    }

    return (
      <>

        {this.obs.continuar == "1" &&

          <>

            <MDBCol md='12'>

              <div className="auth-container">

                <div className="auth-card">

                  <img src="/images/senha.png" className="icon_2fa" />

                  <h2 className="title-cert">Configurar autenticação de dois fatores</h2>

                  <p>
                    O processo de autenticação de dois fatores é necessário neste serviço. <br />
                    Para proteger sua conta, siga as instruções para configurar a autenticação de dois fatores.
                  </p>

                  <div style={{ textAlign: "center" }}>
                    Em caso de dúvidas, disponibilizamos um passo a passo em nossa Central de Ajuda. Basta acessar o link abaixo: <br />
                    <br />
                    <a href="https://help.fipo.com.br/paginas/login_2fa.php" style={{ color: "#3579ea", textDecoration: "underline" }} target="_blank">4. Configurar Dupla Autenticação</a>
                  </div>

                  {!this.obs.needvalidated &&
                    <button className="btn-start-two" onClick={() => {
                      this.handleCodeBackup();
                      handleContinue("2")
                    }}>Gerar Códigos de Backup</button>
                  }

                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                  <button className="btn-start-two" onClick={() => handleContinue("2")}>Começar</button>

                </div>

              </div>

            </MDBCol>

          </>

        }

        {this.obs.continuar == "2" &&
          <>
            <MDBRow>
              <MDBCol>
                <h2 className="title-cert">Configurar autenticação de dois fatores</h2>
              </MDBCol>
            </MDBRow>

            <div style={{ textAlign: "justify" }}>
              <p>Etapa 1</p>
              <b>Instalar um aplicativo de autenticação</b> <br />
              <br />Instale o Google Authenticator no seu dispositivo móvel. Se já possui um aplicativo, basta clicar em <b>Próximo</b> para prosseguir para a próxima etapa.
            </div>

            <br />

            <Tabs
              id="tabs"
              className={"tabsCalculos tabsEmpresaForm"}
              selectedTabId={this.obs.selectedTab}
              onChange={(tabId) => this.obs.selectedTab = String(tabId)}
            >

              <Tab
                id="android"
                title="Android"
                panel={
                  <>
                    <div style={{ textAlign: "center" }}>
                      <p>Escaneie o QR code abaixo para baixar o aplicativo de autenticação 2FA.<br />
                        Se preferir, clique no QR code para ser redirecionado à loja do aplicativo.</p>
                      <img style={{ cursor: "pointer" }} onClick={() => window.open("https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=web_share", "_blank")} src='images/Android.png' width={200} />
                    </div>
                  </>
                }
              />

              <Tab
                id="apple"
                title="Apple"
                panel={
                  <>
                    <div style={{ textAlign: "center" }}>
                      <p>Escaneie o QR code abaixo para baixar o aplicativo de autenticação 2FA.<br />
                        Se preferir, clique no QR code para ser redirecionado à loja do aplicativo.</p>
                      <img style={{ cursor: "pointer" }} onClick={() => window.open("https://apps.apple.com/br/app/google-authenticator/id388497605", "_blank")} src='images/Apple.png' width={200} />
                    </div>
                  </>
                }
              />
            </Tabs>

            <div style={{ textAlign: "center" }}>
              <button className="btn-start-two" onClick={() => handleGenerateContinue("3")}>Próximo</button>
            </div>

          </>
        }

        {this.obs.continuar == "3" &&
          <>
            <MDBRow>
              <MDBCol>
                <h2 className="title-cert">Configurar autenticação de dois fatores</h2>
              </MDBCol>
            </MDBRow>

            <p>Etapa 2</p>

            <b><p>Escaneie o código QR usando seu aplicativo de autenticação</p></b>

            <ul>
              <li>Abra o aplicativo de autenticação</li>
              <li>Toque no ícone "+" </li>
              <li>Escaneie a imagem à abaixo, usando a câmera do seu telefone</li>
            </ul>

            {!this.obs.manual ?

              <p style={{ cursor: "pointer", color: "#3579EA", textDecoration: "underline" }} onClick={() => this.obs.manual = true}>Você está tendo problemas para escanear o Código QR?</p>

              :

              <>

                <p>
                  <b>Alternativamente, insira o código de verificação gerado manualmente</b><br />
                  <br />Se você estiver tendo problemas para escanear o código QR, selecione <b>Entrada manual</b> no seu aplicativo de autenticação e insira as chaves indicadas na tela. As chaves não diferenciam maiúsculas de minúsculas.
                </p>

                <div className="two-factor-manual" onClick={() => copyToClipboard(this.obs.manul_code)}>

                  <span>{this.obs.manul_code}</span> &nbsp;

                  <img style={{ cursor: "pointer", float: "right" }} src='/images/copy.png' width={18} />

                </div>

                <p></p>

              </>

            }

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ padding: '20px', position: 'relative' }} className="select-regras">
                <img src='/images/undo.png' width="20px" style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer" }} onClick={() => handleRegenerate("3")} />

                <div className='qr-code'>
                  <QRCode value={this.obs.code} />
                </div>
              </div>
            </div>

            <div style={{ textAlign: "center" }}>
              <button className="btn-voltar-two" onClick={() => handleContinue("2")}>Voltar</button>
              &nbsp;&nbsp;&nbsp;
              <button className="btn-start-two" onClick={() => handleContinue("4")}>Próximo</button>
            </div>

          </>
        }

        {this.obs.continuar == "4" &&
          <>
            <MDBRow>
              <MDBCol>
                <h2 className="title-cert">Configurar autenticação de dois fatores</h2>
              </MDBCol>
            </MDBRow>

            <p>Etapa 3</p>

            <b><p>Insira o código de verificação</p></b>

            <p>Por fim, você encontrará um código de verificação de seis dígitos no seu aplicativo de autenticação. <br />
              Insira o código na tela para concluir a configuração.</p>

            <AuthCode onChange={handleOnChange} length={6} inputClassName='input-auth' autoFocus />

            <div style={{ textAlign: "center" }}>
              <button className="btn-voltar-two" onClick={() => handleGenerateContinue("3")}>Voltar</button>
              &nbsp;&nbsp;&nbsp;
              <button className="btn-start-two" onClick={() => this.handleValidarCode()}>Verificar e Autenticar</button>
            </div>

          </>
        }

        {this.obs.continuar == "5" &&
          <>
            <MDBRow>
              <MDBCol>
                <h2 className="title-cert">Seus Códigos de Backup</h2>
              </MDBCol>
            </MDBRow>

            <p>Os códigos de backup ajudam você a acessar sua conta quando seu telefone não estiver disponível. <br />
              Recomendamos que você guarde esses códigos em um local seguro.</p>

            <HTMLTable className="table" style={{ width: "100%" }}>
              <tbody>
                {values}
              </tbody>
            </HTMLTable>

            <div style={{ textAlign: "center" }}>
              <button className="btn-start-two" onClick={() => this.onClose()}>OK</button>
            </div>

          </>
        }

      </>
    )
  }
}